<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Sub Kontraktor : {{ kontraktor.namaKontraktor }}
          </div>
          <div class="bg-white rounded-top-10 w-100" style="min-height: 60vh">
            <div class="container p-5">
              <div class="row mb-5">
                <div class="col-md-12">
                  <div class="d-flex">
                    <div class="pr-2" style="margin-right: 1rem">
                      <font-awesome-icon
                        v-if="url_icon == ''"
                        icon="fa-solid fa-building"
                        style="height: 3rem; color: #df4444"
                      />
                      <img :src="url_icon" v-else style="height: 3rem" />
                    </div>
                    <div class="row w-100">
                      <div class="col-md-9">
                        <p
                          class="mb-1"
                          style="
                            font-size: 2rem;
                            line-height: 1.5rem;
                            font-family: 'Inter-Bold';
                          "
                        >
                          {{ kontraktor.namaKontraktor }}
                        </p>
                        <div style="font-size: 1rem">
                          Nilai Prakualifikasi :
                          {{ kontraktor.nilaiPraKplh }} | Predikat PJP :
                          <span
                            v-if="kontraktor.predikat == 'HIJAU'"
                            class="text-success"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'EMAS'"
                            style="color: #e19140"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'BIRU'"
                            style="color: #326bd5"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'HITAM'"
                            style="color: #171716"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          <span
                            v-else-if="kontraktor.predikat == 'MERAH'"
                            class="text-danger"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-square"
                              style=""
                            />
                            {{
                              kontraktor.nilaiPredikat != null
                                ? kontraktor.nilaiPredikat
                                : "-"
                            }}
                          </span>
                          &nbsp;
                          <button
                            type="button"
                            class="btn btn_cari"
                            data-bs-toggle="modal"
                            data-bs-target="#editPjp"
                          >
                            <font-awesome-icon
                              icon="fa-solid fa-edit"
                              style=""
                            />
                            Edit PJP
                          </button>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <!-- <button
                                                type="button"
                                                @click="editProfile()"
                                                class="btn btn_cari w-100"
                                            >
                                                Edit Profile
                                            </button> -->
                        <button
                          type="button"
                          class="btn btn_cari w-100"
                          data-bs-toggle="modal"
                          data-bs-target="#editKualifikasi"
                        >
                          Edit Kualifikasi Usaha
                        </button>
                      </div>
                      <div
                        class="modal fade rounded-top-5"
                        id="editKualifikasi"
                        tabindex="-1"
                        aria-labelledby="editKualifikasi"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog-centered rounded-top-5">
                          <div
                            class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                            style="min-height: 156px; min-width: 350px"
                          >
                            <div
                              class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                              style="
                                min-height: 100px;
                                min-width: 350px;
                                background: rgba(181, 26, 26, 1);
                              "
                            >
                              <div class="d-flex justify-content-end w-100 p-2">
                                <button
                                  type="button"
                                  id="btnClose"
                                  class="btn"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <img
                                    src="../../assets/icons/close_whaite.png"
                                    alt="icon"
                                    width="24"
                                    height="24"
                                  />
                                </button>
                              </div>
                              <div
                                class="p-3 text-white text-center mb-3"
                                style="font-family: Inter, sans-serif"
                              >
                                <h4 class="fw-bold">Edit Kualifikasi Usaha</h4>
                              </div>
                            </div>
                            <div class="modal-body">
                              <div class="p-1">
                                <form @submit.prevent="OnFormSubmit">
                                  <div class="d-flex justify-content-center">
                                    <div
                                      class="form-group mt-1 mb-2"
                                      style="width: 75%"
                                    >
                                      <select
                                        class="form-select form-select-sm"
                                        name="kualifikasiUsaha"
                                        id="kualifikasiUsaha"
                                        v-model="selectedOption"
                                      >
                                        <option disabled value="" selected>
                                          Pilih Kualifikasi Usaha
                                        </option>
                                        <option
                                          :value="row.value"
                                          v-for="(row, index) in options"
                                          :key="index"
                                        >
                                          {{ row.label }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="d-flex justify-content-center">
                                    <button
                                      type="submit"
                                      class="btn btn-sm bg-danger w-75 text-white"
                                    >
                                      Simpan
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-9">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    INFORMASI UMUM
                  </p>
                  <div class="d-flex mb-1">
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Inisial : {{ kontraktor.inisial }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Klasifikasi : {{ kontraktor.jenis }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-location-dot"
                        style=""
                      />
                      {{
                        kontraktor.wilayah == null ? "-" : kontraktor.wilayah
                      }}
                    </p>
                    <p
                      class="me-5"
                      style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                    >
                      Kualifikasi Usaha :
                      {{
                        kontraktor.kualifikasiUsaha == 1
                          ? "Kecil"
                          : kontraktor.kualifikasiUsaha == 2
                          ? "Sedang"
                          : kontraktor.kualifikasiUsaha == 3
                          ? "Besar"
                          : "-"
                      }}
                    </p>
                  </div>
                  <!-- <hr class="hr" /> -->
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    IZIN LEGALITAS
                  </p>
                  <div class="d-flex mb-2">
                    <table class="table table-borderless">
                      <tbody
                        style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                      >
                        <tr>
                          <td width="15%">No. NIB</td>
                          <td width="1%">:</td>
                          <td width="25%">
                            {{ kontraktor.nib == null ? "-" : kontraktor.nib }}
                          </td>
                          <td>
                            <i
                              v-if="kontraktor.fileNib == null"
                              class="text-danger"
                              >Belum ada dokumen NIB</i
                            >
                            <a
                              v-else
                              @click="viewFile(kontraktor.fileNib)"
                              class="text-danger pointer"
                            >
                              <font-awesome-icon
                                style="color: #dd3737; cursor: pointer"
                                icon="fa-solid fa-eye"
                              />
                              Dokumen NIB
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>No. IUJP</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.iujp == null ? "-" : kontraktor.iujp
                            }}
                          </td>
                          <td>
                            <i
                              v-if="kontraktor.fileIujp == null"
                              class="text-danger"
                              >Belum ada dokumen IUJP</i
                            >
                            <a
                              v-else
                              @click="viewFile(kontraktor.fileIujp)"
                              class="text-danger pointer"
                            >
                              <font-awesome-icon
                                style="color: #dd3737; cursor: pointer"
                                icon="fa-solid fa-eye"
                              />
                              Dokumen IUJP
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Masa Berlaku</td>
                          <td>:</td>
                          <td>
                            {{
                              kontraktor.masaBerlaku == null
                                ? "-"
                                : moment(kontraktor.masaBerlaku).format(
                                    "DD MMMM YYYY"
                                  )
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-3">
                  <div
                    class="rounded w-100 p-3"
                    style="min-height: 10vh; background-color: #fff1f1"
                  >
                    <p
                      class="mb-1"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PJO
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Bold'; font-size: 1.1rem"
                    >
                      {{ kontraktor.namaPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      No. Surat Pengesahan :
                      {{ kontraktor.noPengesahanPjo }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      Tgl Surat Pengesahan :
                      {{
                        kontraktor.tglSuratPengesahan != "" &&
                        kontraktor.tglSuratPengesahan != null
                          ? moment(kontraktor.tglSuratPengesahan).format(
                              "DD MMM YYYY"
                            )
                          : "-"
                      }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      <i
                        v-if="kontraktor.filePengesahan == null"
                        class="text-danger"
                        >Belum ada Surat Pengesahan</i
                      >
                      <a
                        v-else
                        @click="viewFile(kontraktor.filePengesahan)"
                        class="text-danger pointer"
                      >
                        <font-awesome-icon
                          style="color: #dd3737; cursor: pointer"
                          icon="fa-solid fa-eye"
                        />
                        Surat Pengesahan
                      </a>
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-user-check"
                        style="color: #df4444"
                      />
                      {{ kontraktor.kompetensiPjo }}
                    </p>
                    <!--                                        <p
                                            class="mb-1"
                                            style="font-family: 'Inter-Regular'; font-size: 0.75rem"
                                        >
                                          <font-awesome-icon
                                              icon="fa-solid fa-clock"
                                              style="color:#df4444"
                                          />
                                          Berlaku hingga 8 Juni 2023
                                        </p>-->
                    <p
                      class="mb-1 mt-2"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      INFORMASI PIC
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-envelope"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picEmail }}
                    </p>
                    <p
                      class="mb-1"
                      style="font-family: 'Inter-Medium'; font-size: 0.8rem"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-phone"
                        style="color: #df4444"
                      />
                      {{ kontraktor.picPhone }}
                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <!-- <p
                                    class="mb-1"
                                    style="font-family: 'Inter-Regular'; font-size: 0.9rem"
                                >
                                  <font-awesome-icon
                                      icon="fa-solid fa-circle-check"
                                      style=""
                                  />
                                  Kode KBLI
                                </p> -->
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    Kode KBLI
                  </p>
                  <div class="table-responsive">
                    <table class="table table-striped rounded">
                      <thead
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr class="table-danger" style="max-height: 5vh">
                          <th width="6%">Kode</th>
                          <th width="20%">Judul</th>
                          <th class="text-center" width="14%">
                            Tingkat Resiko
                          </th>
                          <th class="text-center" width="10%">
                            Sertifikat Standar
                          </th>
                          <th class="text-center" width="10%">Izin</th>
                          <th class="text-center" width="8%">Is Verified</th>
                          <th class="text-center" width="13%">Catatan</th>
                          <th width="10%"></th>
                        </tr>
                      </thead>
                      <tbody
                        style="
                          font-family: 'Inter-Regular';
                          font-style: normal;
                          font-weight: 500;
                          font-size: 14px;
                          line-height: 24px;
                          color: #28293d;
                        "
                      >
                        <tr v-for="kb in kbli" :key="kb.noKbli">
                          <td>
                            {{
                              kb.noKbli.length == 4
                                ? "0" + kb.noKbli
                                : kb.noKbli
                            }}
                          </td>
                          <td>{{ kb.deskripsi }}</td>
                          <td class="text-center">
                            {{ kb.tingkatResikoStr }}
                          </td>
                          <td class="text-center">
                            <a
                              v-if="
                                kb.fileSertifikat != null &&
                                kb.tingkatResiko != 4
                              "
                              @click="viewFile(kb.fileSertifikat)"
                              class="text-decoration-none text-dark pointer"
                            >
                              Terverifikasi
                              <font-awesome-icon
                                size="xl"
                                icon="fa-solid fa-file-arrow-down"
                                class="text-danger"
                              />
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td class="text-center">
                            <a
                              v-if="
                                kb.fileIzin != null && kb.tingkatResiko == 4
                              "
                              @click="viewFile(kb.fileIzin)"
                              class="text-decoration-none text-dark pointer"
                            >
                              Terverifikasi
                              <font-awesome-icon
                                size="xl"
                                icon="fa-solid fa-file-arrow-down"
                                class="text-danger"
                              />
                            </a>
                            <a v-else>-</a>
                          </td>
                          <td class="text-start">
                            <img
                              :src="
                                kb.isVerified
                                  ? require('@/assets/icons/verified.png')
                                  : require('@/assets/icons/close-64.png')
                              "
                              alt="icon"
                              :style="{
                                width: kb.isVerified ? '6rem' : '4rem',
                                marginLeft: kb.isVerified ? '-0.8rem' : '0',
                              }"
                            />
                          </td>
                          <td>{{ kb.notes }}</td>
                          <td class="text-center">
                            <a
                              style="
                                font-family: 'Inter-Bold';
                                font-size: 1.2rem;
                                color: #dd3737;
                                cursor: pointer;
                              "
                              @click="hapusKBLI(kb.id)"
                            >
                              <font-awesome-icon
                                icon="fa-solid fa-trash"
                                style=""
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row" v-if="kontraktor.bidang != null">
                <div class="col-md-4">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    BIDANG
                  </p>
                  <ul class="list-group w-100">
                    <li
                      v-for="(bid, index) in bd"
                      :key="index"
                      :class="{
                        'list-group-item': true,
                        'list-bidang': true,
                        'bg-gray': index % 2 === 1,
                      }"
                    >
                      {{ bid }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-8">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    SUB BIDANG
                  </p>
                  <table>
                    <tbody>
                    <tr
                      v-for="(sbid, index) in sbd"
                      :key="index"
                      :class="{ 'bg-gray': index % 2 === 1 }"
                    >
                      <td width="50%">{{ sbid.sb }}</td>
                      <td width="15%">
                        <img
                          :src="
                            sbid.is_verified
                              ? require('@/assets/icons/verified.png')
                              : require('@/assets/icons/close-64.png')
                          "
                          alt="icon"
                          :style="{
                            width: sbid.is_verified ? '6rem' : '4rem',
                            marginLeft: sbid.is_verified ? '.8rem' : '0',
                          }"
                        />
                      </td>
                      <td width="40%">{{ sbid.notes }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" v-else>
                <p
                  class="mb-1 text-center"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  Tidak Ada Data Bidang dan Sub Bidang
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <div
    class="modal fade rounded-top-5"
    id="editPjp"
    tabindex="-1"
    aria-labelledby="editPjp"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit PJP</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-1">
            <form @submit.prevent="OnFormSubmitPjp">
              <div class="d-flex justify-content-center">
                <div class="form-group mt-1 mb-2" style="width: 75%">
                  <div class="row mb-4">
                    <div class="col-md-6">
                      <label for="predikatPjp" class="form-label fs-8 fw-bold"
                        >Predikat PJP</label
                      >
                      <select
                        class="form-select form-select-sm"
                        name="predikatPjp"
                        id="predikatPjp"
                        v-model="predikatPjp"
                      >
                        <option disabled value="" selected>
                          Pilih Predikat PJP
                        </option>
                        <option
                          :value="row.value"
                          v-for="(row, index) in pjpOptions"
                          :key="index"
                        >
                          {{ row.label }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6">
                      <label for="nilaiPjp" class="form-label fs-8 fw-bold"
                        >Nilai PJP</label
                      >
                      <input
                        type="number"
                        step="any"
                        class="form-control fs-9"
                        id="nilaiPjp"
                        placeholder="Masukkan Nilai PJP"
                        v-model="nilaiPjp"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
table tr td,
table tr th {
  padding: 0.75rem 1rem;
}

section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.list-bidang {
  border-radius: 0px !important;
}

.bg-gray {
  background-color: #f2f2f5;
}

.bg-red-ss {
  background-color: #f8d7da;
}
.rounded-top-10 {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
</style>
<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";

import axios from "axios";

import {
  API_BASE_URL,
  CMS_DELETE_KBLI,
  CMS_DOWNLOAD,
  CMS_GET_DETAILKONTRAKTOR,
  CMS_VIEW_DOCUMENT,
  CMS_VIEW_IMAGE,
  CMS_KONTRAKTOR,
} from "../../constants.js";
import Swal from "sweetalert2";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;
const url_download = API_BASE_URL + CMS_DOWNLOAD;
const url_delete_kbli = API_BASE_URL + CMS_DELETE_KBLI;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;
const url_kontraktor = API_BASE_URL + CMS_KONTRAKTOR;

export default {
  mixins: [GlobalDataMixin],
  name: "ProfilePage",
  components: { DefaultLayout },
  data() {
    return {
      kontraktor: {},
      bidang: [],
      kbli: [],
      bd: [],
      sbd: [],
      // subkontraktor:['PT Sapta Indrasejati (SIS)','PT Rezki Batulicin Transport','PT Golden Energi Cemerlang Lestari (GECL)', 'PT Merdeka Sejati','PT Golden Gemilang','PT Jaya Sentosa'],
      subkontraktor: [],
      url_icon: "",
      selectedOption: null,
      predikatPjp: null,
      nilaiPjp: null,
      options: [
        { value: 1, label: "Kecil" },
        { value: 2, label: "Sedang" },
        { value: 3, label: "Besar" },
      ],
      pjpOptions: [
        { value: "HIJAU", label: "HIJAU" },
        { value: "EMAS", label: "EMAS" },
        { value: "BIRU", label: "BIRU" },
        { value: "HITAM", label: "HITAM" },
        { value: "MERAH", label: "MERAH" },
      ],
    };
  },
  mounted() {
    this.fetchData(this.$route.params.id);
  },
  methods: {
    fetchData(id) {
      axios
        .get(url + id)
        .then((response) => {
          console.log("asas =>", response);
          this.kontraktor = response.data.detailKontraktor;
          this.url_icon =
            this.kontraktor.image != null && this.kontraktor.image != ""
              ? API_BASE_URL + CMS_VIEW_IMAGE + this.kontraktor.image
              : "";

          this.selectedOption = this.kontraktor.kualifikasiUsaha;
          this.predikatPjp = this.kontraktor.predikat;
          this.nilaiPjp = this.kontraktor.nilaiPredikat;

          // loop bidang-subbidang
          var arr_bid = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              arr_bid.push({
                bidang: b + ". " + key,
                subBidang: b + "." + sb + ". " + subi[xx],
              });
              asbd.push({
                sb: b + "." + sb + ". " + subi[xx].split("-")[0],
                is_verified: JSON.parse(subi[xx].split("-")[1]),
                notes:
                  subi[xx].split("-")[2] === "null"
                    ? null
                    : subi[xx].split("-")[2],
              });
              sb++;
            }
          }
          this.bidang = arr_bid;
          // end loop bidang-subbidang

          this.kbli = response.data.dataKbli;
          this.bd = abd;
          this.sbd = asbd;
          this.subkontraktor = response.data.subkontraktor;
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    editProfile() {
      this.$router.push("/editprofile");
    },
    addSubkontraktor() {
      this.$router.push("/addsubkontraktor");
    },
    hapusKBLI(id) {
      Swal.fire({
        title: "Hapus KBLI",
        text: "Apakah anda yakin akan menghapus data kbli ini ?",
        icon: "confirmation",
        showCancelButton: true,
        showConfirmButton: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteKbli(id);
        }
      });
    },
    deleteKbli(id) {
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe";
      axios
        .get(url_delete_kbli, {
          params: {
            id: id,
          },
          headers: {
            role: role,
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          Swal.fire({
            title: "Hapus KBLI",
            text: "Data KKBLI telah dihapus !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan (" + error.response.data.message + ")",
          });
        });
    },
    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
    OnFormSubmit() {
      console.log("data nya = ", this.selectedOption);
      this.simpanKualifikasiUsaha(this.selectedOption);
    },
    simpanKualifikasiUsaha(selectedOption) {
      try {
        const payload = {
          kualifikasiUsaha: selectedOption,
        };
        axios.patch(url_kontraktor + this.$route.params.id, payload, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanEditProfile: ", response);
          window.location.reload();
        })
        .catch((error) => {
          console.log("error simpanEditProfile : ", error);
        });
      } catch (error) {
        console.log("error simpanKualifikasiUsaha : ", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan (" + error.response.data.message + ")",
        });
      }
    },
    OnFormSubmitPjp() {
      this.simpanPredikatPjp(this.predikatPjp, this.nilaiPjp);
    },
    simpanPredikatPjp(predikatPjp, nilaiPjp) {
      const payload = {
        predikat: predikatPjp,
        nilaiPredikat: nilaiPjp,
      };
      axios.patch(url_kontraktor + this.$route.params.id, payload, {
        headers: {
          role: this.userData.role,
          Authorization: "Bearer " + this.userData.token,
          accept: "*/*",
        },
      })
      .then((response) => {
        console.log("response simpanPredikatPjp: ", response);
        window.location.reload();
      })
      .catch((error) => {
        console.log("error simpanPredikatPjp : ", error);
      });
    },
  },
};
</script>
